export const AI_VIDEO_GENERATION_STATES = {
  error: 'error',
  finished: 'finished',
  generating: 'preparing_ai_video',
  preparing_media: 'preparing_media'
}

export const VIDEO_RENDER_STATES = {
  error: 'error',
  preparing: 'preparing',
  rending: 'rending',
  uploading: 'uploading',
  rended: 'rended'
}
